var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "price-info-area" }, [
    typeof _vm.lodging.price === "undefined"
      ? _c(
          "div",
          { staticClass: "price" },
          [
            _vm.fromPriceDisplay !== "0" && _vm.fromPriceDisplay !== ""
              ? [
                  _vm._v(_vm._s(_vm.translations.sentences.fromPrice) + " "),
                  _c(
                    "span",
                    {
                      staticClass: "highlight",
                      attrs: {
                        itemprop: "priceRange",
                        content: _vm.fromPriceDisplay,
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.fromPriceDisplay) +
                          " " +
                          _vm._s(_vm.currencyDisplay)
                      ),
                    ]
                  ),
                  _vm.fromFeePriceDisplay !== false
                    ? [
                        _c("br"),
                        _c("span", { staticClass: "fromFeePrice" }, [
                          _vm._v(_vm._s(_vm.fromFeePriceDisplay)),
                        ]),
                      ]
                    : _vm._e(),
                ]
              : [
                  _c("span", { staticClass: "not-available" }, [
                    _vm._v(_vm._s(_vm.translations.terms.notAvailable)),
                  ]),
                ],
          ],
          2
        )
      : _vm.lodging.price.price !== _vm.lodging.price.normalPrice
      ? _c("div", { staticClass: "price lastMinutePrice" }, [
          _c("div", { staticClass: "lastMinuteBefore" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.translations.terms.before) + " "),
            _c("span", { staticClass: "linethrough" }, [
              _vm._v(
                _vm._s(_vm.normalPrice) + " " + _vm._s(_vm.currencyDisplay)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lastMinuteTotal" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.translations.terms.now) +
                " " +
                _vm._s(_vm.priceDisplay) +
                " " +
                _vm._s(_vm.currencyDisplay) +
                "\n\t\t"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lastMinuteSave" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.translations.terms.save) +
                " " +
                _vm._s(_vm.savePriceDisplay) +
                " " +
                _vm._s(_vm.currencyDisplay) +
                "\n\t\t"
            ),
          ]),
          _vm._v(" "),
          _vm.feePriceDisplay !== false
            ? _c("span", { staticClass: "fromFeePrice" }, [
                _vm._v(_vm._s(_vm.feePriceDisplay)),
              ])
            : _vm._e(),
        ])
      : _c(
          "div",
          { staticClass: "price" },
          [
            _c(
              "span",
              {
                staticClass: "highlight",
                attrs: { itemprop: "priceRange", content: _vm.priceDisplay },
              },
              [
                _vm._v(
                  _vm._s(_vm.priceDisplay) + " " + _vm._s(_vm.currencyDisplay)
                ),
              ]
            ),
            _vm._v(" "),
            _vm.feePriceDisplay !== false
              ? [
                  _c("br"),
                  _c("span", { staticClass: "fromFeePrice" }, [
                    _vm._v(_vm._s(_vm.feePriceDisplay)),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
    _vm._v(" "),
    typeof _vm.lodging.additionals !== "undefined" &&
    _vm.lodging.additionals.length > 0
      ? _c("div", { staticClass: "additionals-text right" }, [
          _vm._v(_vm._s(_vm.translations.sentences.additionalArrivalDates)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "orange-btn base-btn orange-glossy-gradient",
        attrs: { href: _vm.parsedUrl },
      },
      [
        _c("i", { staticClass: "cfa cfa-info" }, [
          _c("img", { attrs: { src: _vm.infoIconUrl } }),
        ]),
        _vm._v(" " + _vm._s(_vm.translations.sentences.viewMore)),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }